import { Directive, ElementRef, Input, OnInit } from '@angular/core';

@Directive({
  selector: '[DateFormatted]'
})
export class DateFormatDirective {

  @Input() format: string = 'dd/MM/yyyy HH:mm'; // Formato por defecto
  @Input() dateValue: string = ''; // Nuevo input para la fecha
  timeZone: string = 'America/Asuncion';

  constructor(private el: ElementRef) {}

  ngOnInit() {
    this.formatDate();
  }

  private formatDate() {
    const date = new Date(this.dateValue);

    // Adjust the date to the local time zone
    const localOffset = date.getTimezoneOffset() * 60000; // Offset in milliseconds
    const localDate = new Date(date.getTime() + localOffset);

    const options: Intl.DateTimeFormatOptions = {
      timeZone: this.timeZone,
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      hour12: false  // Formato de 24 horas
    };
  
    const formattedDate = localDate.toLocaleString('es-PY', options);
    const formattedDateWithoutComma = formattedDate.replace(/,/g, '');

    this.el.nativeElement.textContent = formattedDateWithoutComma;
  }
}
